export const DATETIME_FORMAT: { [key: string]: string } = {
    'en-GB': 'MM/dd/yyyy HH:mm:ss',
    'en-US': 'dd/MM/yyyy HH:mm:ss',
    'nb-NO': 'dd.MM.yyyy HH:mm:ss',
    'sv-SE': 'yyyy-MM-dd HH:mm:ss',
    'fi-FI': 'd.M.yyyy HH:mm:ss',
    'nl-NL': 'd-M-yy HH:mm:ss',
    'da-DK': 'dd/MM/yy HH:mm:ss'
}
